<template>
  <div class="form-container">
    <div class="form-content">
      <h1 class="title">纪检举报信箱 - 信件提交</h1>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="120px"
        class="letter-form"
      >
        <el-form-item
          label="写信目的"
          prop="purpose"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-radio-group v-model="form.purpose">
            <el-radio label="申诉">申诉</el-radio>
            <el-radio label="举报">举报</el-radio>
            <el-radio label="建议">建议</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="主要诉求"
          prop="mainRequest"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input
            v-model="form.mainRequest"
            type="textarea"
            :rows="3"
            placeholder="请简要描述您的主要诉求"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>

        <el-form-item
          label="诉求方式"
          prop="requestType"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-radio-group v-model="form.requestType">
            <el-radio label="匿名">匿名</el-radio>
            <el-radio label="实名">实名</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="被反映人"
          prop="reportedPerson"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input
            v-model="form.reportedPerson"
            placeholder="请输入被反映人姓名"
          />
        </el-form-item>

        <el-form-item
          label="单位职务"
          prop="unitPosition"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input v-model="form.unitPosition" placeholder="请输入单位职务" />
        </el-form-item>

        <el-form-item
          label="诉求详细内容"
          prop="content"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input
            v-model="form.content"
            type="textarea"
            :rows="6"
            placeholder="请详细描述您的诉求内容"
          />
        </el-form-item>

        <el-form-item
          label="相关附件"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-upload
            ref="uploadRef"
            :action="uploadUrl"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
            :before-upload="beforeUpload"
            accept=".jpg,.jpeg,.png,.gif,.doc,.docx,.pdf,.mp4,.avi,.mov"
            :limit="1"
            :on-exceed="handleExceed"
          >
            <!-- multiple -->
            <el-button type="primary">选择文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持 PDF、Word、图片、视频等格式，单个文件不超过 100MB
              </div>
            </template>
          </el-upload>
        </el-form-item>

        <el-form-item
          label="手机号码"
          prop="phoneNumber"
          v-if="form.requestType === '实名'"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input v-model="form.phoneNumber" placeholder="请输入手机号码" />
        </el-form-item>

        <el-form-item
          label="反映人"
          prop="reporter"
          v-if="form.requestType === '实名'"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <el-input v-model="form.reporter" placeholder="请输入反映人姓名" />
        </el-form-item>

        <el-form-item
          label="验证码"
          prop="captchaVerified"
          :label-position="ismobileModel ? 'top' : 'right'"
        >
          <verify
            container-id="verify-container"
            mode="fixed"
            :captchaType="'blockPuzzle'"
            :imgSize="
              ismobileModel
                ? { width: '100%', height: '200px' }
                : { width: '100%', height: '300px' }
            "
            :barSize="
              ismobileModel
                ? { width: '100%', height: '45px' }
                : { width: '100%', height: '60px' }
            "
            :showBar="true"
            @ready="handleCaptchaReady"
            @success="handleCaptchaSuccess"
            @error="handleCaptchaError"
            ref="verify"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm"
            :loading="submitting"
            size="large"
          >
            提交信件
          </el-button>
          <el-button @click="resetForm" size="large">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import Verify from "../../components/verifition/Verify.vue";
import { isMobile } from "@components/verifition/utils/util";
export default {
  name: "Form",
  components: {
    Verify,
  },
  data() {
    return {
      ismobileModel: false,
      form: {
        purpose: "",
        mainRequest: "",
        requestType: "匿名",
        reportedPerson: "",
        unitPosition: "",
        content: "",
        phoneNumber: "",
        reporter: "",
        captchaVerified: false,
      },
      rules: {
        purpose: [
          { required: true, message: "请选择写信目的", trigger: "change" },
        ],
        mainRequest: [
          { required: true, message: "请输入主要诉求", trigger: "blur" },
        ],
        requestType: [
          { required: true, message: "请选择诉求方式", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入诉求详细内容", trigger: "blur" },
        ],
        phoneNumber: [
          {
            validator: (rule, value, callback) => {
              if (this.form.requestType === "实名") {
                if (!value) {
                  callback(new Error("请输入手机号码"));
                } else if (!/^1[3-9]\d{9}$/.test(value)) {
                  callback(new Error("请输入正确的手机号码"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        reporter: [
          {
            validator: (rule, value, callback) => {
              if (this.form.requestType === "实名") {
                if (!value) {
                  callback(new Error("请输入反映人姓名"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        captchaVerified: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请完成滑动验证"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      fileList: [],
      attachments: [],
      uploadUrl: "http://emailapi.scwmjt.com/api/web/file/front/upload",
      submitting: false,
      captchaVerifyData: null,
      newAttachments: "",
    };
  },
  methods: {
    handleCaptchaReady() {
      // 验证码加载完成回调
      console.log("验证码加载完成");
    },
    handleCaptchaSuccess(params) {
      // 验证成功回调，params 是返回的二次验证参数
      this.form.captchaVerified = true;
      this.captchaVerifyData = params;
      this.$message.success("验证成功");
    },
    handleCaptchaError() {
      // 验证失败回调
      this.form.captchaVerified = false;
      this.captchaVerifyData = null;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isLt100M) {
        this.$message.error("文件大小不能超过 100MB！");
        return false;
      }
      return true;
    },
    //超出文件数量限制回调
    handleExceed(files, fileList) {
      this.$message.warning(
        "仅支持上传1个附件，请先删除已上传的文件再重新选择"
      );
    },
    handleUploadSuccess(response, file) {
      if (response.success) {
        this.attachments = [response.data];
        this.newAttachments = response.data;
        this.$message.success("文件上传成功");
        console.log("=>文件上传", this.attachments);
      } else {
        this.$message.error("文件上传失败");
      }
    },
    handleRemove(file, fileList) {
      // 从 attachments 中移除对应的附件信息
      const fileName = file.name;
      this.attachments = this.attachments.filter(
        (att) => att.fileName !== fileName
      );
      this.newAttachments = "";
      this.fileList = fileList;
    },
    async submitForm() {
      await this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // 验证码校验
          if (!this.form.captchaVerified) {
            this.$message.error("请完成滑动验证");
            return;
          }

          // 实名验证
          if (this.form.requestType === "实名") {
            if (!this.form.phoneNumber || !this.form.reporter) {
              this.$message.error("实名提交需要填写手机号码和反映人姓名");
              return;
            }
          }

          // 二次验证验证码
          if (!this.captchaVerifyData) {
            this.$message.error("请完成滑动验证");
            return;
          }

          // try {
          //   const verifyResponse = await api.post(
          //     "/captcha/verify",
          //     this.captchaVerifyData
          //   );
          //   if (!verifyResponse.success) {
          //     this.$message.error("验证码验证失败，请重新验证");
          //     if (this.$refs.verify) {
          //       this.$refs.verify.refresh();
          //     }
          //     this.form.captchaVerified = false;
          //     this.captchaVerifyData = null;
          //     return;
          //   }
          // } catch (error) {
          //   this.$message.error("验证码验证失败，请重新验证");
          //   if (this.$refs.verify) {
          //     this.$refs.verify.refresh();
          //   }
          //   this.form.captchaVerified = false;
          //   this.captchaVerifyData = null;
          //   return;
          // }

          this.submitting = true;
          try {
            const formData = {
              ...this.form,
              attachments: this.newAttachments,
              ...this.captchaVerifyData,
            };
            console.log("formData: ", formData);
            // 移除验证码字段，不需要提交到后端
            delete formData.captchaVerified;

            const response = await api.post("/letter/submit", formData);
            if (response.success) {
              this.$message.success("信件提交成功！");
              setTimeout(() => {
                this.$router.push("/notice");
              }, 2000);
            } else {
              this.$message.error(response.message || "提交失败");
            }
          } catch (error) {
            this.$message.error("提交失败，请重试");
          } finally {
            this.submitting = false;
          }
        }
      });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.fileList = [];
      this.attachments = [];
      this.form.captchaVerified = false;
      this.captchaVerifyData = null;
      if (this.$refs.verify) {
        this.$refs.verify.refresh();
      }
    },
    checkDevice() {
      this.ismobileModel = isMobile();
      // this.ismobileModel = true;
      // console.log("ismobileModel:", this.ismobileModel);
      // this.$forceUpdate();
    },
  },
  mounted() {
    this.checkDevice();
  },
};
</script>

<style scoped>
.form-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.form-content {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 30px 20px;
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}

.letter-form {
  padding: 40px;
}

.verification-box {
  display: flex;
  align-items: center;
}

.verification-question {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

@media (max-width: 768px) {
  .letter-form {
    padding: 20px;
  }

  .title {
    font-size: 20px;
    padding: 20px;
  }

  .verification-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .verification-box .el-input {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
</style>

